import { defineStore } from 'pinia'
import { computed, ref } from "vue"
import { toast } from "vue3-toastify"

import { useAuthStore } from "@/stores/auth.js";
import { useEnvironmentStore } from "@/stores/environmentStore.js";

import http from "@/plugins/http.js";

export const useDeviceStore = defineStore( 'deviceStore', () => {
  const deviceUUID = ref( null )
  // const _isDevice = ref( false )
  const device = ref( null )

  function fetchDeviceUUID() {
    http
      .get( 'http://localhost:9123/identify/' )
      .then( ( response ) => {
        if ( response.status === 204 ) {
          http
            .get( 'http://localhost:9123/register/' )
            .then( ( response ) => {
              deviceUUID.value = response.data.id
            })
            .catch( ( err ) => {
              if ( useAuthStore().isAdmin ) {
                toast.error( err.response.data.detail )
              }
            })
        }

        else if ( response.status !== 204 ) {
          deviceUUID.value = response.data.id
        }

        if ( deviceUUID.value ) {
          fetchDeviceDetails()
        }
      })
      .catch( ( err ) => {
        if ( useAuthStore().isAdmin ) {
          toast.error( err.response.data.detail )
        }
      })
  }

  function fetchDeviceDetails() {
    http
      .get( '/session/device/' + deviceUUID.value )
      .then( ( response ) => {
        device.value = response.data
      })
      .catch( ( err ) => {
        if ( useAuthStore().isAdmin ) {
          toast.error( err.response.data.detail )
        }
      })
  }

  function registerDevice( data ) {
    if ( deviceUUID.value ) {
      http
        .post( '/admin/device_registrations', {
          name: data.name,
          device_name: data.device_name,
          uuid: deviceUUID.value
        } )
        .then( ( response ) => {
          device.value = response.data
        } )
        .catch( ( err ) => {
          toast.error( err.response.data.detail )
        } )
    }
  }

  function deregisterDevice() {
    if ( device ) {
      http
        .delete( `/admin/device_registrations/${deviceUUID.value}` )
        .then( ( response ) => {
          toast.warning( 'The Device has been De-Registered!' )
          device.value = null
        })
        .catch( ( err ) => {
          toast.error( err.response.data.detail )
        } )
    }
  }

  // const isDevice = computed( () => deviceUUID.value )
  // const isRegistered = computed( () => _isDevice.value && deviceUUID.value )
  const canBeRegistered = computed( () => ( !device.value && deviceUUID.value ) )// || ( !useEnvironmentStore().isProduction() && !isRegistered ) )

  const enableGame = computed( () => {
    const es = useEnvironmentStore()
    if ( es.isProduction() ) {
      return device.value
    }
    else {
      return true
    }
  } )

  return { deviceUUID, fetchDeviceUUID, registerDevice, deregisterDevice, enableGame, device,
           canBeRegistered }
})
/*
    Prod w/ device  Prod w/o device  Non Prod w/ device   Non prod w/o device
    Show            Hide             Show                 Show w/ warning

*/